import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import { useRef, useState, useCallback, useLayoutEffect } from 'react';
import { useResizeObserver } from './use-resize-observer';
import { debounce } from 'lodash';
export function useHandleOverflow(_ref) {
  var itemCount = _ref.itemCount;
  var itemRefs = useRef(new _Map());
  var extraCountRef = useRef(null);

  var _useState = useState(itemCount),
      _useState2 = _slicedToArray(_useState, 2),
      visibleItemCount = _useState2[0],
      setVisibleItemCount = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOverflowing = _useState4[0],
      setIsOverflowing = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      recalculateLayout = _useState6[0],
      setRecalculateLayout = _useState6[1];

  var debounceSetRecalculateLayout = useCallback(debounce(setRecalculateLayout, 50), []);
  var containerRef = useResizeObserver(function () {
    debounceSetRecalculateLayout(true);
  }, []);
  var extraItemCount = itemCount - visibleItemCount;
  useLayoutEffect(function () {
    setIsOverflowing(false);
    setRecalculateLayout(true);
  }, [itemCount]);
  useLayoutEffect(function () {
    if (recalculateLayout) {
      if (containerRef.current) {
        var _context;

        var items = _Array$from(_valuesInstanceProperty(_context = itemRefs.current).call(_context));

        var containerStyle = getComputedStyle(containerRef.current);
        var containerXPadding = (_parseInt(containerStyle.paddingLeft) || 0) + (_parseInt(containerStyle.paddingRight) || 0); // This assumes the items are spaced with flex gap at the
        // moment, which may be a bold assumption

        var containerColumnGap = _parseInt(containerStyle.gap) || 0;
        var containerWidth = containerRef.current.offsetWidth - containerXPadding;
        var visibleCount = items.length;

        var combinedItemsWidth = _reduceInstanceProperty(items).call(items, function (acc, item, index) {
          if (item) {
            return acc + item.offsetWidth + ( // If this isn't the last item add the column gap
            index === items.length - 1 ? 0 : containerColumnGap);
          }

          return acc;
        }, 0); // Start from the end and work our way backwards
        // This makes it easier to know how much room we
        // have left after we add the extra count element
        // We also stop iterating before the last element
        // because we never want to remove it


        for (var i = items.length - 1; i > 0; i--) {
          if (combinedItemsWidth <= containerWidth) {
            break;
          }

          var item = items[i];
          visibleCount--;
          combinedItemsWidth -= item.offsetWidth + containerColumnGap; // Add the extra count element to our total if we have
          // removed the last element

          if (extraCountRef.current && i === items.length - 1) {
            combinedItemsWidth += containerColumnGap + extraCountRef.current.offsetWidth;
          }
        } // If we only have one element left and we're still
        // overflowing then set some state so the user
        // can implement some logic to truncate that item


        if (visibleCount === 1 && combinedItemsWidth > containerWidth) {
          setIsOverflowing(true);
        }

        setVisibleItemCount(visibleCount);
      }

      setRecalculateLayout(false);
    }
  }, [containerRef, recalculateLayout]);
  return {
    containerRef: containerRef,
    itemRefs: itemRefs,
    extraCountRef: extraCountRef,
    visibleItemCount: visibleItemCount,
    extraItemCount: extraItemCount,
    isOverflowing: isOverflowing,
    recalculateLayout: recalculateLayout
  };
}